import React, { useCallback, useState } from 'react'
import { BiDotsVertical } from 'react-icons/bi'
import { IoTrailSignSharp } from 'react-icons/io5'
import { useNavigate } from 'react-router-dom'
import { Diagnosis } from '../../types/Diagnosis'
import { ContextMenu } from '../ContextMenu'

export const DiagnosisList = ({diagnosis}:Props) => {

    const [contexOpen,setContextOpen] = useState<boolean>(false)

    const navigate = useNavigate()

    const renderTotal = useCallback((diagnosis:Diagnosis):number => {
        let total=0
        let score =0
        if(diagnosis.total)
        total = diagnosis.total
        if(diagnosis.score)
        score = diagnosis.score
        let data = ((100*score)/total);
        return data;
    },[])

    const renderTotalAvage = useCallback((diagnosis:Diagnosis):string => {
        let total=0
        let avarega =0
        if(diagnosis.total)
        total = diagnosis.total
        if(diagnosis.average)
        avarega = diagnosis.average
        let data = (((100*avarega)/total)/10)*1;
        return data.toFixed(1);
    },[])

    return (
        <>
          <div className="col-span-1 text-xl font-bold">{(renderTotal(diagnosis)/10).toFixed(1)}</div>
                    <div className="col-span-4">{diagnosis.name}</div>
                    <div className="col-span-4">
                        <div className="flex items-center gap-x-3">
                            <div className="border-2 border-gray-200 w-full">
                                <div className="bg-primary h-4" style={{width:renderTotal(diagnosis)+"%"}}>
                                </div>
                            </div>
                            <div className='text-gray-500'>{diagnosis.replyAt}</div>
                        </div>
                    </div>
                    <div className="col-span-2 text-center text-xl font-bold">{renderTotalAvage(diagnosis)}</div>
                    <div className="col-span-1 relative">
                        <BiDotsVertical className="cursor-pointer text-primary text-2xl" onClick={()=>setContextOpen(prev => prev ? false : true)} />
                       <div className='absolute w-full'>
                        <ContextMenu open={contexOpen} close={()=>setContextOpen(false)}>
                            <div className='flex gap-x-2 items-center cursor-pointer'
                                onClick={()=>navigate(`/osc/resultado/${diagnosis.id}`)}
                            >
                               <IoTrailSignSharp className='text-green-500'/> Ir para trilha
                            </div>
                            
                        </ContextMenu>
                        </div>
                    </div>
        </>
    )
}

interface Props {
    diagnosis:Diagnosis
}